import React, { useState, useEffect, useRef } from 'react';
import { db, auth } from './firebase';
import { collection, onSnapshot, query, orderBy, limit, where, doc, updateDoc, getDocs, getDoc, setDoc } from 'firebase/firestore';
import { signInWithEmailAndPassword, onAuthStateChanged, signOut } from 'firebase/auth';
import TenantOnboarding from './TenantOnboarding';
import LandingPage from './LandingPage';
import { can, getRoleLabel } from './roles';
import DocumentVault from './DocumentVault';
import ShiftScheduler from './ShiftScheduler';
import LeaveRequests from './LeaveRequests';
import NotificationCentre from './NotificationCentre';
import ChatCentre from './ChatCentre';
import VisitorManagement from './VisitorManagement';
import CaseManagement from './CaseManagement';
import IncidentModal from './IncidentModal';
import InviteOfficerModal from './InviteOfficerModal';
import IncidentsPage from './IncidentsPage';
import PatrolsPage from './PatrolsPage';
import CheckpointsPage from './CheckpointsPage';
import AnalyticsPage from './AnalyticsPage';
import EmergencyPage from './EmergencyPage';
import PatrolModal from './PatrolModal';
import { exportToExcel } from './excelExport';
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, LineChart, Line } from 'recharts';

// ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ STYLES ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬
const SIDEBAR_WIDTH = 190;

const NAV_GROUPS = [
  { id: 'operations', label: 'Operations', tabIds: ['live', 'emergency', 'incidents', 'patrols', 'checkpoints'] },
  { id: 'workforce', label: 'Workforce', tabIds: ['team', 'shifts', 'leave'] },
  { id: 'records', label: 'Records', tabIds: ['vault', 'cases', 'visitors'] },
  { id: 'comms', label: 'Comms', tabIds: ['notifications', 'chat'] },
  { id: 'insights', label: 'Insights', tabIds: ['analytics'] },
];

const S = {
  app: { background: '#F4F2EE', minHeight: '100vh', color: '#1A1A2E', fontFamily: 'system-ui, sans-serif', overflowX: 'hidden', display: 'flex', flexDirection: 'column' },
  topBar: { background: '#0c1626', padding: '10px 20px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', position: 'sticky', top: 0, zIndex: 100, gap: 16, flexShrink: 0 },
  topBarLeft: { display: 'flex', alignItems: 'center', gap: 10, flexShrink: 0, width: SIDEBAR_WIDTH, boxSizing: 'border-box' },
  wordmark: { fontSize: 14, fontWeight: 800, letterSpacing: 1.5, color: '#F8FAFC', whiteSpace: 'nowrap' },
  searchWrap: { flex: '1 1 auto', display: 'flex', justifyContent: 'center', minWidth: 0, padding: '0 16px' },
  searchField: { display: 'flex', alignItems: 'center', gap: 8, background: '#18233a', border: '1px solid #2a3a52', borderRadius: 8, padding: '7px 12px', width: '100%', maxWidth: 400, color: '#8B95A7' },
  searchInput: { background: 'transparent', border: 'none', outline: 'none', color: '#F8FAFC', fontSize: 13, width: '100%' },
  topBarRight: { display: 'flex', alignItems: 'center', gap: 6, flexShrink: 0 },
  iconBtn: { background: 'transparent', border: 'none', color: '#8B95A7', cursor: 'pointer', padding: 7, borderRadius: 6, display: 'flex' },
  profileCluster: { display: 'flex', alignItems: 'center', gap: 8, background: 'transparent', border: 'none', cursor: 'pointer', padding: '4px 6px', borderRadius: 8, color: '#F8FAFC' },
  avatar: { width: 28, height: 28, borderRadius: '50%', background: '#C9A84C', color: '#1A1A2E', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 12, fontWeight: 800, flexShrink: 0 },
  profileInfo: { textAlign: 'left', lineHeight: 1.25 },
  profileNameTxt: { fontSize: 12, fontWeight: 700, color: '#F8FAFC', whiteSpace: 'nowrap', maxWidth: 140, overflow: 'hidden', textOverflow: 'ellipsis' },
  profileRoleTxt: { fontSize: 10, color: '#8B95A7' },
  dropdown: { position: 'absolute', top: 'calc(100% + 8px)', right: 0, background: '#FFFFFF', border: '1px solid #EAE6DE', borderRadius: 10, boxShadow: '0 8px 24px rgba(0,0,0,0.18)', width: 240, zIndex: 200, overflow: 'hidden' },
  dropdownHeader: { padding: '12px 14px', borderBottom: '1px solid #EAE6DE' },
  dropdownEmail: { fontSize: 12, fontWeight: 700, color: '#1A1A2E', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' },
  dropdownSub: { fontSize: 11, color: '#9B8F7A', marginTop: 2 },
  dropdownItem: (disabled) => ({ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', textAlign: 'left', padding: '9px 14px', background: 'transparent', border: 'none', cursor: disabled ? 'default' : 'pointer', fontSize: 13, color: disabled ? '#B7AE9E' : '#1A1A2E' }),
  soonTag: { fontSize: 9, fontWeight: 700, color: '#9B8F7A', background: '#F4F0E8', padding: '2px 6px', borderRadius: 10, letterSpacing: 0.5, textTransform: 'uppercase' },
  shellRow: { flex: 1, display: 'flex', minHeight: 0 },
  sidebar: (open) => ({ width: open ? SIDEBAR_WIDTH : 0, flexShrink: 0, background: '#0c1626', overflowY: 'auto', overflowX: 'hidden', paddingTop: 8, paddingBottom: 12, transition: 'width 0.15s' }),
  sidebarGroup: { marginBottom: 4 },
  sidebarGroupHeader: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', background: 'transparent', border: 'none', color: '#7C8AA0', textTransform: 'uppercase', letterSpacing: 1, fontSize: 10, fontWeight: 700, padding: '10px 16px 6px', cursor: 'pointer', whiteSpace: 'nowrap' },
  sidebarItem: (active) => ({ display: 'flex', alignItems: 'center', gap: 10, width: '100%', textAlign: 'left', background: active ? '#16273f' : 'transparent', border: 'none', borderLeft: active ? '3px solid #C9A84C' : '3px solid transparent', color: active ? '#F8FAFC' : '#9CA3AF', fontWeight: active ? 600 : 400, padding: '9px 14px 9px 13px', cursor: 'pointer', fontSize: 13, whiteSpace: 'nowrap' }),
  main: { flex: 1, minWidth: 0, overflowY: 'auto' },
  actionRow: { display: 'flex', justifyContent: 'flex-end', gap: 8, padding: '14px 20px 0' },
  grid2: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: 12 },
  grid4: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))', gap: 12 },
  card: { background: '#FFFFFF', border: '1px solid #1E3A5F', borderRadius: 12, padding: 16 },
  cardLabel: { fontSize: 11, color: '#9CA3AF', textTransform: 'uppercase', letterSpacing: 1, marginBottom: 8, fontWeight: 700 },
  statNum: (color) => ({ fontSize: 32, fontWeight: 900, color: color || '#F8FAFC' }),
  section: { padding: '16px 24px', width: '100%', boxSizing: 'border-box' },
  sectionTitle: { fontSize: 11, color: '#9B8F7A', textTransform: 'uppercase', letterSpacing: 1, fontWeight: 700, marginBottom: 12 },
  table: { width: '100%', borderCollapse: 'collapse' },
  th: { textAlign: 'left', padding: '8px 12px', fontSize: 11, color: '#9CA3AF', borderBottom: '1px solid #EAE6DE', textTransform: 'uppercase', letterSpacing: 1 },
  td: { padding: '10px 12px', fontSize: 13, borderBottom: '1px solid #F4F0E8' },
  badge2: (color) => ({ background: color + '22', color: color, padding: '3px 10px', borderRadius: 20, fontSize: 11, fontWeight: 700, display: 'inline-block' }),
  btn: (color) => ({ background: color || '#1E3A5F', color: '#fff', border: 'none', padding: '6px 14px', borderRadius: 8, cursor: 'pointer', fontSize: 12, fontWeight: 600 }),
  input: { background: '#FAFAF8', border: '1px solid #E2DDD6', color: '#1A1A2E', padding: '10px 14px', borderRadius: 8, fontSize: 14, width: '100%', boxSizing: 'border-box' },
  threatBar: (_color) => ({ background: '#FFFBF0', border: '1.5px solid #E8C96A', borderRadius: 12, padding: 16, marginBottom: 16 }),
  dot: (color) => ({ width: 10, height: 10, borderRadius: '50%', background: color, display: 'inline-block', marginRight: 8 }),
  // Global search dropdown
  searchDropdown: { position: 'absolute', top: 'calc(100% + 6px)', left: 0, right: 0, background: '#FFFFFF', border: '1px solid #EAE6DE', borderRadius: 10, boxShadow: '0 10px 30px rgba(0,0,0,0.20)', maxHeight: 420, overflowY: 'auto', zIndex: 300, padding: 6 },
  searchStatus: { padding: '14px 12px', fontSize: 13, color: '#9B8F7A', textAlign: 'center' },
  searchGroupLabel: { fontSize: 10, fontWeight: 800, color: '#9B8F7A', textTransform: 'uppercase', letterSpacing: 1, padding: '10px 10px 4px' },
  searchResult: { display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 1, width: '100%', textAlign: 'left', background: 'transparent', border: 'none', borderRadius: 7, padding: '7px 10px', cursor: 'pointer' },
  searchResultPrimary: { fontSize: 13, fontWeight: 600, color: '#1A1A2E' },
  searchResultSecondary: { fontSize: 11, color: '#9B8F7A' },
};

// ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ HELPERS ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬
const escalationColor = (level) => {
  if (!level) return '#2E7D32';
  if (level.includes('3') || level.includes('Emergency')) return '#D32F2F';
  if (level.includes('2') || level.includes('Serious')) return '#F57F17';
  return '#2E7D32';
};

const threatColor = (level) => {
  const colors = { CRITICAL: '#8B0000', SEVERE: '#D32F2F', SUBSTANTIAL: '#F57F17', MODERATE: '#C9A84C', LOW: '#2E7D32' };
  return colors[level] || '#F57F17';
};

const formatTime = (ts) => {
  if (!ts) return '';
  try {
    const d = ts.toDate ? ts.toDate() : new Date(ts);
    return d.toLocaleString('en-GB', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' });
  } catch { return ''; }
};

const SearchIcon = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="8" /><line x1="21" y1="21" x2="16.65" y2="16.65" /></svg>
);
const BellIcon = () => (
  <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M18 8a6 6 0 0 0-12 0c0 7-3 9-3 9h18s-3-2-3-9" /><path d="M13.73 21a2 2 0 0 1-3.46 0" /></svg>
);
const HelpIcon = () => (
  <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10" /><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 2-3 4" /><line x1="12" y1="17" x2="12.01" y2="17" /></svg>
);
const ChevronDownIcon = ({ style }) => (
  <svg style={style} width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="6 9 12 15 18 9" /></svg>
);
const MenuIcon = () => (
  <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="3" y1="6" x2="21" y2="6" /><line x1="3" y1="12" x2="21" y2="12" /><line x1="3" y1="18" x2="21" y2="18" /></svg>
);

const TabIcon = ({ id }) => {
  const p = { width: 16, height: 16, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 2, strokeLinecap: 'round', strokeLinejoin: 'round' };
  switch (id) {
    case 'live': return <svg {...p}><polyline points="3 12 8 12 10 7 14 17 16 12 21 12" /></svg>;
    case 'emergency': return <svg {...p}><path d="M12 9v4" /><path d="M12 17h.01" /><path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0Z" /></svg>;
    case 'incidents': return <svg {...p}><path d="M9 2h6l1 4H8l1-4Z" /><path d="M4 6h16l-1.58 13.42A2 2 0 0 1 16.44 21H7.56a2 2 0 0 1-1.98-1.58L4 6Z" /></svg>;
    case 'patrols': return <svg {...p}><path d="M12 21s7-6.5 7-12a7 7 0 1 0-14 0c0 5.5 7 12 7 12Z" /><circle cx="12" cy="9" r="2.5" /></svg>;
    case 'team': return <svg {...p}><circle cx="9" cy="8" r="3" /><circle cx="17" cy="9" r="2.5" /><path d="M2 20c0-3 3-5 7-5s7 2 7 5" /><path d="M15 15c3 0 5.5 2 5.5 5" /></svg>;
    case 'shifts': return <svg {...p}><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 3" /></svg>;
    case 'leave': return <svg {...p}><rect x="3" y="4" width="18" height="17" rx="2" /><path d="M3 9h18" /><path d="M8 2v4" /><path d="M16 2v4" /></svg>;
    case 'vault': return <svg {...p}><rect x="4" y="10" width="16" height="10" rx="2" /><path d="M8 10V7a4 4 0 0 1 8 0v3" /></svg>;
    case 'cases': return <svg {...p}><path d="M3 7h18v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7Z" /><path d="M9 7V5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2" /></svg>;
    case 'visitors': return <svg {...p}><rect x="3" y="5" width="18" height="14" rx="2" /><circle cx="9" cy="10.5" r="2" /><path d="M6 16c0-1.7 1.5-3 3-3s3 1.3 3 3" /><path d="M15 9h4" /><path d="M15 13h4" /></svg>;
    case 'notifications': return <svg {...p}><path d="M18 8a6 6 0 0 0-12 0c0 7-3 9-3 9h18s-3-2-3-9" /><path d="M13.73 21a2 2 0 0 1-3.46 0" /></svg>;
    case 'chat': return <svg {...p}><path d="M21 11.5a8.4 8.4 0 0 1-1 4 8.5 8.5 0 0 1-7.5 4.5 8.4 8.4 0 0 1-4-1L3 20l1-5.5a8.4 8.4 0 0 1-1-4 8.5 8.5 0 0 1 4.5-7.5 8.4 8.4 0 0 1 4-1h.5a8.48 8.48 0 0 1 8 8v.5Z" /></svg>;
    case 'analytics': return <svg {...p}><line x1="4" y1="20" x2="4" y2="12" /><line x1="10" y1="20" x2="10" y2="6" /><line x1="16" y1="20" x2="16" y2="14" /><line x1="21" y1="20" x2="3" y2="20" /></svg>;
    default: return null;
  }
};

// ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ LOGIN ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬
function Login({ onLogin }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showOnboarding, setShowOnboarding] = useState(false);
  const [showLanding, setShowLanding] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      await signInWithEmailAndPassword(auth, email, password);
    } catch (err) {
      setError('Invalid credentials');
    } finally {
      setLoading(false);
    }
  };

  if (showLanding) return <LandingPage onGetStarted={() => { setShowLanding(false); setShowOnboarding(true); }} />;
  return (
    <div style={{ ...S.app, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      {showOnboarding && <TenantOnboarding onComplete={() => setShowOnboarding(false)} />}
      <div style={{ ...S.card, width: 380, border: '1px solid #1E3A5F' }}>
        <div style={{ marginBottom: 24 }}>
          <div style={{ fontSize: 24, fontWeight: 900, letterSpacing: 2 }}>OSECURE OPS</div>
          <div style={{ color: '#9CA3AF', fontSize: 13 }}>Control Room Dashboard</div>
        </div>
        <form onSubmit={handleLogin}>
          <div style={{ marginBottom: 12 }}>
            <input style={S.input} type="email" placeholder="Email address"
              value={email} onChange={e => setEmail(e.target.value)} required />
          </div>
          <div style={{ marginBottom: 16 }}>
            <input style={S.input} type="password" placeholder="Password"
              value={password} onChange={e => setPassword(e.target.value)} required />
          </div>
          {error && <div style={{ color: '#D32F2F', fontSize: 13, marginBottom: 12 }}>{error}</div>}
          <button type="submit" style={{ ...S.btn(), width: '100%', padding: 12, fontSize: 14 }} disabled={loading}>
            {loading ? 'Signing in...' : 'Sign in to oSecure Ops'}
          </button>
        </form>
        <div style={{textAlign:'center',marginTop:16}}>
          <span style={{color:'#9CA3AF',fontSize:13}}>New organisation? </span>
          <span style={{color:'#C9A84C',fontSize:13,cursor:'pointer',fontWeight:700}} onClick={()=>setShowOnboarding(true)}>Register here &rarr;</span>
        </div>
        <div style={{textAlign:'center',marginTop:8}}>
          <span style={{color:'#1E3A5F',fontSize:12,cursor:'pointer'}} onClick={()=>setShowLanding(true)}>&larr; Back to website</span>
        </div>
      </div>
    </div>
  );
}

// ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ LIVE OPS DASHBOARD ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬
// Table row with a visible hover state, used for clickable feeds.
function FeedRow({ onClick, children }) {
  const [hover, setHover] = React.useState(false);
  return (
    <tr onClick={onClick} onMouseEnter={() => setHover(true)} onMouseLeave={() => setHover(false)}
        style={{ cursor: 'pointer', background: hover ? '#F4F0E8' : 'transparent', transition: 'background 0.12s' }}>
      {children}
    </tr>
  );
}

// Div card with a hover state; only interactive when `clickable`.
function HoverCard({ onClick, clickable, style, children }) {
  const [hover, setHover] = React.useState(false);
  return (
    <div onClick={clickable ? onClick : undefined}
         onMouseEnter={() => setHover(true)} onMouseLeave={() => setHover(false)}
         style={{ ...style, borderRadius: 6, cursor: clickable ? 'pointer' : 'default',
                  background: clickable && hover ? '#F4F0E8' : (style && style.background) || 'transparent',
                  transition: 'background 0.12s' }}>
      {children}
    </div>
  );
}

// ── GLOBAL SEARCH ──
// True cross-module search over the tenant-scoped, in-memory arrays. Result
// groups are gated by the caller's permissions so a user never sees results for
// a module they cannot open (no dead ends). Debounced ~300ms.
//
// FUTURE WORK: this is client-side substring matching. Fine at hundreds of docs
// (current scale); past ~10k docs this needs a real search service (Algolia /
// Typesense) with server-side indexing — a full-text index, not prefix scans.
function GlobalSearch({ query, onQueryChange, incidents, patrols, visitors, cases, users, userRole, onOpen }) {
  const [debounced, setDebounced] = React.useState(query);
  const [open, setOpen] = React.useState(false);
  const wrapRef = React.useRef(null);

  React.useEffect(() => {
    const t = setTimeout(() => setDebounced(query), 300);
    return () => clearTimeout(t);
  }, [query]);

  React.useEffect(() => {
    const onDown = (e) => { if (wrapRef.current && !wrapRef.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', onDown);
    return () => document.removeEventListener('mousedown', onDown);
  }, []);

  const q = debounced.trim().toLowerCase();
  const settled = query.trim() === debounced.trim();
  const hit = (v) => (v == null ? '' : String(v)).toLowerCase().includes(q);

  const groups = q.length < 2 ? [] : [
    can(userRole, 'viewIncidents') && {
      key: 'incidents', label: 'Incidents', type: 'incident',
      items: incidents.filter(i => hit(i.siteName) || hit(i.category) || hit(i.title) || hit(i.description)).slice(0, 6),
      primary: (i) => i.siteName || i.title || 'Incident',
      secondary: (i) => [i.category, (i.escalationLevel || '').replace('Level ', 'L')].filter(Boolean).join(' · '),
    },
    can(userRole, 'viewPatrols') && {
      key: 'patrols', label: 'Patrols', type: 'patrol',
      items: patrols.filter(p => hit(p.route_name) || hit(p.officer_name) || hit(p.officer_email) || hit(p.site) || hit(p.observations)).slice(0, 6),
      primary: (p) => p.route_name || 'Patrol',
      secondary: (p) => [p.officer_name || p.officer_email, p.site].filter(Boolean).join(' · '),
    },
    can(userRole, 'viewTeam') && {
      key: 'visitors', label: 'Visitors', type: 'visitor',
      items: visitors.filter(v => hit(v.visitor_name) || hit(v.visitor_email) || hit(v.visitor_company) || hit(v.host_name)).slice(0, 6),
      primary: (v) => v.visitor_name || 'Visitor',
      secondary: (v) => [v.visitor_company, v.host_name && `Host: ${v.host_name}`].filter(Boolean).join(' · '),
    },
    can(userRole, 'viewTeam') && {
      key: 'cases', label: 'Cases', type: 'case',
      items: cases.filter(c => hit(c.title) || hit(c.case_number) || hit(c.description) || hit(c.status)).slice(0, 6),
      primary: (c) => c.title || c.case_number || 'Case',
      secondary: (c) => [c.case_number, c.status].filter(Boolean).join(' · '),
    },
    can(userRole, 'viewTeam') && {
      key: 'team', label: 'Team', type: 'officer',
      items: users.filter(u => hit(u.display_name) || hit(u.name) || hit(u.email)).slice(0, 6),
      primary: (u) => u.display_name || u.name || u.email || 'Officer',
      secondary: (u) => [getRoleLabel(u.role), u.email].filter(Boolean).join(' · '),
    },
  ].filter(Boolean).filter(g => g.items.length > 0);

  const totalResults = groups.reduce((n, g) => n + g.items.length, 0);
  const showDropdown = open && debounced.trim().length >= 2;

  return (
    <div style={S.searchWrap} ref={wrapRef}>
      <div style={{ position: 'relative', width: '100%', maxWidth: 400 }}>
        <div style={S.searchField}>
          <SearchIcon />
          <input
            style={S.searchInput}
            placeholder="Search sites, incidents, officers, patrols"
            value={query}
            onChange={e => { onQueryChange(e.target.value); setOpen(true); }}
            onFocus={() => setOpen(true)}
            onKeyDown={e => { if (e.key === 'Escape') setOpen(false); }}
          />
        </div>
        {showDropdown && (
          <div style={S.searchDropdown}>
            {!settled ? (
              <div style={S.searchStatus}>Searching…</div>
            ) : totalResults === 0 ? (
              <div style={S.searchStatus}>No results for "{debounced.trim()}"</div>
            ) : (
              groups.map(g => (
                <div key={g.key}>
                  <div style={S.searchGroupLabel}>{g.label}</div>
                  {g.items.map((it, i) => (
                    <HoverCard key={i} clickable
                      onClick={() => { onOpen(g.type, it, { navigate: true }); setOpen(false); onQueryChange(''); }}
                      style={S.searchResult}>
                      <span style={S.searchResultPrimary}>{g.primary(it)}</span>
                      <span style={S.searchResultSecondary}>{g.secondary(it)}</span>
                    </HoverCard>
                  ))}
                </div>
              ))
            )}
          </div>
        )}
      </div>
    </div>
  );
}

// ── PATROL COMPLIANCE ────────────────────────────────────────────────────────
// Deviations are FLAGGED, never blocked or hidden — they exist for supervisor
// attention.
//
// Only ONE signal is measurable today: checkpoints missed. The other two render
// "unmeasured" and must never render as a pass:
//   • checkpoint `time_limit_minutes` — written into every point but never
//     measured, and no baseline is defined anywhere (from patrol start? from the
//     previous checkpoint?). Any number here would be invented.
//   • `route_time_limit_minutes` — well-defined, but null on every route, so it
//     is dormant rather than passing.
// Missing-required-photo is deliberately absent: the officer app blocks submit
// on it (patrol_routes_screen.dart:996), so a completed patrol provably has its
// photos. That is the block working, not a gap to report.
// See docs/FOLLOWUP-recurring-patrol-compliance.md.
const toDateSafe = (ts) => {
  if (!ts) return null;
  try {
    const d = ts.toDate ? ts.toDate() : new Date(ts);
    return isNaN(d.getTime()) ? null : d;
  } catch { return null; }
};

const isToday = (ts) => {
  const d = toDateSafe(ts);
  if (!d) return false;
  const now = new Date();
  return d.getFullYear() === now.getFullYear() && d.getMonth() === now.getMonth() && d.getDate() === now.getDate();
};

// Ad-hoc patrols carry no route, so they have no checkpoints to miss.
const isAdHoc = (p) => p.ad_hoc === true;

// Single source of truth for "today" — LiveOps' stat card and the compliance
// panel both read this, so the two cannot report different counts.
const patrolsToday = (patrols) => (patrols || []).filter((p) => isToday(p.completed_at));

const deviationsFor = (p) => {
  const devs = [];
  const total = p.points_total || 0;
  const checked = p.points_checked || 0;
  if (total > 0 && checked < total) devs.push(`${checked}/${total} checkpoints`);
  return devs;
};

function PatrolCompliance({ patrols, onOpenPatrol }) {
  const todays = patrolsToday(patrols);
  const adHoc = todays.filter(isAdHoc);
  // Route patrols only: ad-hoc write 0/0 completed:true by construction, so
  // including them would inflate the rate. points_total > 0 guards 0/0.
  const route = todays.filter((p) => !isAdHoc(p) && (p.points_total || 0) > 0);
  const done = route.filter((p) => p.completed === true);
  const rate = route.length > 0 ? Math.round((done.length / route.length) * 100) : null;
  const flagged = route
    .map((p) => ({ patrol: p, devs: deviationsFor(p) }))
    .filter((x) => x.devs.length > 0);

  const AMBER = '#F57F17';

  return (
    <div style={{ ...S.card, marginBottom: 16 }}>
      <div style={S.sectionTitle}>Patrol compliance — today</div>

      <div style={{ ...S.grid4, marginBottom: 14 }}>
        <div>
          <div style={S.cardLabel}>Completed today</div>
          <div style={S.statNum('#2E7D52')}>
            {done.length}
            <span style={{ fontSize: 13, color: '#9B8F7A', fontWeight: 500 }}> of {route.length}</span>
          </div>
        </div>
        <div>
          <div style={S.cardLabel}>Completion rate</div>
          {rate === null ? (
            <div style={{ fontSize: 15, fontWeight: 600, color: '#9B8F7A', paddingTop: 8 }}>
              No route patrols today
            </div>
          ) : (
            <div style={S.statNum(rate === 100 ? '#2E7D52' : AMBER)}>{rate}<span style={{ fontSize: 15 }}>%</span></div>
          )}
        </div>
        <div>
          <div style={S.cardLabel}>Deviations flagged</div>
          <div style={S.statNum(flagged.length > 0 ? AMBER : '#2E7D52')}>{flagged.length}</div>
        </div>
        <div>
          <div style={S.cardLabel}>Ad-hoc logged</div>
          <div style={S.statNum('#1A1A2E')}>{adHoc.length}</div>
          <div style={{ fontSize: 10, color: '#9B8F7A', marginTop: 2 }}>excluded from rate</div>
        </div>
      </div>

      {/* Dormant checks — shown so they read as unmeasured, not as a pass. */}
      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 12 }}>
        <span style={S.badge2('#9B8F7A')} title="time_limit_minutes is recorded per checkpoint but never measured, and no baseline is defined.">
          Checkpoint time limits: unmeasured
        </span>
        <span style={S.badge2('#9B8F7A')} title="route_time_limit_minutes is not configured on any route.">
          Route time limits: unmeasured
        </span>
      </div>

      {flagged.length === 0 ? (
        <div style={{ fontSize: 13, color: '#9B8F7A' }}>
          {route.length === 0
            ? 'No route patrols completed today.'
            : 'No deviations flagged on today’s patrols.'}
        </div>
      ) : (
        flagged.map(({ patrol, devs }, i) => (
          <HoverCard key={patrol.id || i} clickable onClick={() => onOpenPatrol(patrol)}
            style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '9px 6px', borderBottom: '1px solid #F4F0E8' }}>
            <div style={{ width: 8, height: 8, borderRadius: '50%', background: AMBER, flexShrink: 0 }} />
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: 13, fontWeight: 600, color: '#1A1A2E' }}>
                {patrol.route_name || 'Patrol'}
              </div>
              <div style={{ fontSize: 11, color: '#9B8F7A' }}>
                {patrol.site || 'N/A'} · {patrol.officer_email || 'Unknown'} · {formatTime(patrol.completed_at)}
              </div>
            </div>
            {devs.map((d, j) => (
              <span key={j} style={S.badge2(AMBER)}>{d}</span>
            ))}
          </HoverCard>
        ))
      )}
    </div>
  );
}

function LiveOps({ incidents, officers, patrols, threatLevel, onOpenIncident, onOpenOfficer, canOpenOfficer, onOpenPatrol }) {
  const [editingThreat, setEditingThreat] = React.useState(false);

  const updateThreatLevel = async (level) => {
    try {
      await setDoc(doc(db, 'setting', 'threat_level'), { level });
      setEditingThreat(false);
    } catch (err) {
      console.error('Threat level update failed:', err);
      alert('Update failed: ' + err.message);
    }
  };
  const openIncidents = incidents.filter(i => i.status === 'open');
  const criticalIncidents = incidents.filter(i => i.escalationLevel?.includes('3') || i.escalationLevel?.includes('Emergency'));

  return (
    <div style={S.section}>
      {/* Threat Level */}
      <div style={S.threatBar(threatColor(threatLevel))}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div>
            <div style={{ fontSize: 11, color: '#9CA3AF', letterSpacing: 1, fontWeight: 700 }}>UK THREAT LEVEL</div>
            <div style={{ fontSize: 26, fontWeight: 800, color: '#C9A84C' }}>{threatLevel}</div>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 8 }}>
            <div style={{ fontSize: 12, color: '#6B6055' }}>
              {threatLevel === 'CRITICAL' ? 'An attack is expected imminently' :
               threatLevel === 'SEVERE' ? 'An attack is highly likely' :
               threatLevel === 'SUBSTANTIAL' ? 'An attack is likely' :
               threatLevel === 'MODERATE' ? 'An attack is possible' : 'An attack is unlikely'}
            </div>
            <button onClick={() => setEditingThreat(!editingThreat)}
              style={{ background: '#1A1A2E', color: '#C9A84C', border: 'none', padding: '5px 12px', borderRadius: 6, cursor: 'pointer', fontSize: 11, fontWeight: 700 }}>
              {editingThreat ? 'Cancel' : 'Update level'}
            </button>
            {editingThreat && (
              <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                {['CRITICAL', 'SEVERE', 'SUBSTANTIAL', 'MODERATE', 'LOW'].map(level => (
                  <button key={level} onClick={() => updateThreatLevel(level)}
                    style={{ background: threatLevel === level ? '#1E3A5F' : '#1E3A5F22', color: '#F8FAFC', border: '1px solid #1E3A5F', padding: '5px 14px', borderRadius: 6, cursor: 'pointer', fontSize: 12, fontWeight: threatLevel === level ? 700 : 400 }}>
                    {level}
                  </button>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Stats */}
      <div style={{ ...S.grid4, marginBottom: 16 }}>
        <div style={{ ...S.card, borderColor: '#E2DDD6' }}>
          <div style={S.cardLabel}>Officers on shift</div>
          <div style={S.statNum('#1A1A2E')}>{officers.length}</div>
        </div>
        <div style={{ ...S.card, borderColor: openIncidents.length > 0 ? '#D32F2F' : '#2E7D32' }}>
          <div style={S.cardLabel}>Open incidents</div>
          <div style={S.statNum(openIncidents.length > 0 ? '#D32F2F' : '#2E7D32')}>{openIncidents.length}</div>
        </div>
        <div style={{ ...S.card, borderColor: criticalIncidents.length > 0 ? '#D32F2F' : '#1E3A5F' }}>
          <div style={S.cardLabel}>Critical</div>
          <div style={S.statNum(criticalIncidents.length > 0 ? '#D32F2F' : '#9CA3AF')}>{criticalIncidents.length}</div>
        </div>
        {/* Not "active": patrols are only written to Firestore on submit, so no
            in-progress patrol document exists to count. This is the recent feed. */}
        <div style={{ ...S.card, borderColor: '#2E7D32' }}>
          <div style={S.cardLabel}>Recent patrols</div>
          <div style={S.statNum('#2E7D32')}>{patrols.length}</div>
          <div style={{ fontSize: 10, color: '#B7AE9E', marginTop: 2 }}>most recent 20</div>
        </div>
      </div>

      <PatrolCompliance patrols={patrols} onOpenPatrol={onOpenPatrol} />

      <div style={S.grid2}>
        {/* Live incident feed */}
        <div style={S.card}>
          <div style={S.sectionTitle}>Live incident feed</div>
          {incidents.length === 0 ? (
            <div style={{ color: '#9CA3AF', fontSize: 13 }}>No incidents reported.</div>
          ) : (
            <table style={S.table}>
              <thead>
                <tr>
                  <th style={S.th}>Site</th>
                  <th style={S.th}>Category</th>
                  <th style={S.th}>Level</th>
                  <th style={S.th}>Time</th>
                </tr>
              </thead>
              <tbody>
                {incidents.slice(0, 8).map((inc, i) => (
                  <FeedRow key={i} onClick={() => onOpenIncident(inc)}>
                    <td style={S.td}>{inc.siteName || 'Unknown'}</td>
                    <td style={S.td}>{inc.category || 'N/A'}</td>
                    <td style={S.td}>
                      <span style={S.badge2(escalationColor(inc.escalationLevel))}>
                        {(inc.escalationLevel || 'L1').replace('Level ', 'L')}
                      </span>
                    </td>
                    <td style={{ ...S.td, color: '#9CA3AF' }}>{formatTime(inc.createdAt)}</td>
                  </FeedRow>
                ))}
              </tbody>
            </table>
          )}
        </div>

        {/* Officers on shift */}
        <div style={S.card}>
          <div style={S.sectionTitle}>Officers on shift</div>
          {officers.length === 0 ? (
            <div style={{ color: '#9CA3AF', fontSize: 13 }}>No officers currently on shift.</div>
          ) : (
            officers.map((officer, i) => (
              <HoverCard key={i} clickable={canOpenOfficer} onClick={() => onOpenOfficer(officer)}
                style={{ display: 'flex', alignItems: 'center', padding: '8px 4px', borderBottom: '1px solid #1E3A5F22' }}>
                <div style={{ width: 36, height: 36, borderRadius: 8, background: '#1A1A2E', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 800, marginRight: 12, color: '#C9A84C' }}>
                  {(officer.guardEmail || '?')[0].toUpperCase()}
                </div>
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: 13, fontWeight: 600 }}>{officer.guardEmail || 'Unknown'}</div>
                  <div style={{ fontSize: 11, color: '#9CA3AF' }}>Checked in {formatTime(officer.checkedInAt)}</div>
                </div>
                <span style={S.dot('#2E7D32')} />
              </HoverCard>
            ))
          )}
        </div>
      </div>

      {/* Avg Response Time and Compliance Score were hardcoded literals (4.2 min,
          94%) — nothing computed them. Neither has an honest source yet, so both
          read "Not yet measured" rather than a fabricated figure:
            • Response time: incidents carry no acknowledged/attended timestamp,
              only createdAt + approved_at (report approval, not response).
              emergency_alerts.timeline mixes naive-local times from the app
              (emergency_response_screen.dart:51 DateTime.now().toIso8601String())
              with UTC from the dashboard, so any average would be wrong by the
              device's UTC offset.
            • Compliance Score: no agreed definition exists. Patrol completion is
              shown, honestly labelled, in the panel above. */}
      <div style={{display:'grid',gridTemplateColumns:'repeat(4,1fr)',gap:14,marginTop:16}}>
        <div style={{...S.card,borderLeft:'3px solid #E2DDD6'}}>
          <div style={S.cardLabel}>Avg Response Time</div>
          <div style={{fontSize:15,fontWeight:600,color:'#9B8F7A',paddingTop:6}}>Not yet measured</div>
          <div style={{fontSize:10,color:'#B7AE9E',marginTop:2}}>no response timestamp captured</div>
        </div>
        <div style={{...S.card,borderLeft:'3px solid #2E7D52'}}>
          <div style={S.cardLabel}>Patrols Logged</div>
          <div style={{fontSize:24,fontWeight:800,color:'#2E7D52'}}>{patrolsToday(patrols).length}<span style={{fontSize:12,color:'#9B8F7A',fontWeight:500}}> today</span></div>
        </div>
        <div style={{...S.card,borderLeft:'3px solid #1A1A2E'}}>
          <div style={S.cardLabel}>Recent Incidents</div>
          <div style={{fontSize:24,fontWeight:800,color:'#1A1A2E'}}>{incidents.length}<span style={{fontSize:12,color:'#9B8F7A',fontWeight:500}}> loaded</span></div>
          <div style={{fontSize:10,color:'#B7AE9E',marginTop:2}}>most recent 50</div>
        </div>
        <div style={{...S.card,borderLeft:'3px solid #E2DDD6'}}>
          <div style={S.cardLabel}>Compliance Score</div>
          <div style={{fontSize:15,fontWeight:600,color:'#9B8F7A',paddingTop:6}}>Not yet measured</div>
          <div style={{fontSize:10,color:'#B7AE9E',marginTop:2}}>no agreed definition</div>
        </div>
      </div>

      <div style={{...S.card,marginTop:16}}>
        <div style={S.sectionTitle}>Recent Activity</div>
        <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:24}}>
          <div>
            <div style={{fontSize:11,color:'#9B8F7A',fontWeight:700,marginBottom:12,textTransform:'uppercase',letterSpacing:1}}>Latest Incidents</div>
            {incidents.length===0
              ? <div style={{color:'#9B8F7A',fontSize:13}}>No incidents recorded.</div>
              : incidents.slice(0,4).map((inc,i)=>(
                <HoverCard key={i} clickable onClick={()=>onOpenIncident(inc)}
                  style={{display:'flex',alignItems:'center',gap:10,padding:'9px 6px',borderBottom:'1px solid #F4F0E8'}}>
                  <div style={{width:8,height:8,borderRadius:'50%',background:escalationColor(inc.escalationLevel),flexShrink:0}}/>
                  <div style={{flex:1}}>
                    <div style={{fontSize:13,fontWeight:600,color:'#1A1A2E'}}>{inc.siteName||'Unknown site'}</div>
                    <div style={{fontSize:11,color:'#9B8F7A'}}>{inc.category} · {formatTime(inc.createdAt)}</div>
                  </div>
                  <span style={{fontSize:10,fontWeight:700,padding:'2px 8px',borderRadius:20,background:escalationColor(inc.escalationLevel)+'18',color:escalationColor(inc.escalationLevel)}}>
                    {(inc.escalationLevel||'L1').replace('Level ','L')}
                  </span>
                </HoverCard>
              ))
            }
          </div>
          <div>
            <div style={{fontSize:11,color:'#9B8F7A',fontWeight:700,marginBottom:12,textTransform:'uppercase',letterSpacing:1}}>Officers on Duty</div>
            {officers.length===0
              ? <div style={{color:'#9B8F7A',fontSize:13}}>No officers on shift.</div>
              : officers.slice(0,4).map((o,i)=>(
                <HoverCard key={i} clickable={canOpenOfficer} onClick={()=>onOpenOfficer(o)}
                  style={{display:'flex',alignItems:'center',gap:10,padding:'9px 6px',borderBottom:'1px solid #F4F0E8'}}>
                  <div style={{width:34,height:34,borderRadius:8,background:'#1A1A2E',display:'flex',alignItems:'center',justifyContent:'center',fontSize:12,fontWeight:800,color:'#C9A84C',flexShrink:0}}>
                    {(o.guardEmail||'?')[0].toUpperCase()}
                  </div>
                  <div style={{flex:1}}>
                    <div style={{fontSize:12,fontWeight:600,color:'#1A1A2E'}}>{o.guardEmail}</div>
                    <div style={{fontSize:11,color:'#9B8F7A'}}>Since {formatTime(o.checkedInAt)}</div>
                  </div>
                  <div style={{width:8,height:8,borderRadius:'50%',background:'#2E7D52'}}/>
                </HoverCard>
              ))
            }
          </div>
        </div>
      </div>
    </div>
  );
}

// ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ INCIDENTS ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬
function Incidents({ incidents, onEdit }) {
  const [selected, setSelected] = useState(null);
  const [filter, setFilter] = useState('all');

  const filtered = incidents.filter(inc => {
    if (filter === 'open') return inc.status === 'open';
    if (filter === 'critical') return inc.escalationLevel?.includes('3');
    if (filter === 'pending') return inc.report_status === 'pending' || inc.report_status === 'pending_review';
    return true;
  });

  const approveIncident = async (incId) => {
    const q = query(collection(db, 'incidents'), where('id', '==', incId));
    const snap = await getDocs(q);
    if (!snap.empty) {
      await updateDoc(snap.docs[0].ref, { report_status: 'approved', status: 'closed' });
    }
  };

  return (
    <div style={S.section}>
      <div style={{ display: 'flex', gap: 8, marginBottom: 16 }}>
        {['all', 'open', 'critical', 'pending'].map(f => (
          <button key={f} onClick={() => setFilter(f)}
            style={{ background: filter === f ? '#1A1A2E' : '#FFFFFF', border: '1px solid #E2DDD6', color: filter === f ? '#C9A84C' : '#6B6055', padding:'6px 16px', borderRadius:6, cursor:'pointer', fontSize:12, fontWeight: filter === f ? 700 : 500 }}>
            {f.charAt(0).toUpperCase() + f.slice(1)}
          </button>
        ))}
      </div>

      <div style={S.grid2}>
        <div style={S.card}>
          <div style={S.sectionTitle}>Incidents ({filtered.length})</div>
          <table style={S.table}>
            <thead>
              <tr>
                <th style={S.th}>ID</th>
                <th style={S.th}>Site</th>
                <th style={S.th}>Level</th>
                <th style={S.th}>Status</th>
                <th style={S.th}>Action</th>
              </tr>
            </thead>
            <tbody>
              {filtered.map((inc, i) => (
                <tr key={i} style={{ cursor: 'pointer' }} onClick={() => onEdit && onEdit(inc)}>
                  <td style={{ ...S.td, fontFamily: 'monospace', fontSize: 11 }}>{inc.id || inc.incident_id || 'N/A'}</td>
                  <td style={S.td}>{inc.siteName || 'Unknown'}</td>
                  <td style={S.td}><span style={S.badge2(escalationColor(inc.escalationLevel))}>{(inc.escalationLevel || 'L1').replace('Level ', 'L')}</span></td>
                  <td style={S.td}><span style={S.badge2(inc.status === 'open' ? '#D32F2F' : '#2E7D32')}>{inc.status || 'open'}</span></td>
                  <td style={S.td}>
                    {inc.report_status === 'submitted' && (
                      <button style={S.btn('#2E7D32')} onClick={(e) => { e.stopPropagation(); approveIncident(inc.id); }}>
                        Approve
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {selected && (
          <div style={S.card}>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 12 }}>
              <div style={S.sectionTitle}>Incident detail</div>
              <button onClick={() => setSelected(null)} style={{ ...S.btn('#D32F2F'), padding: '4px 10px' }}>ÃƒÂ¢Ã…â€œÃ¢â‚¬Â¢</button>
            </div>
            <div style={{ fontSize: 11, fontFamily: 'monospace', color: '#9CA3AF', marginBottom: 8 }}>{selected.id}</div>
            <div style={{ marginBottom: 8 }}><span style={S.badge2(escalationColor(selected.escalationLevel))}>{selected.escalationLevel}</span></div>
            <div style={{ fontSize: 13, marginBottom: 6 }}><b>Site:</b> {selected.siteName}</div>
            <div style={{ fontSize: 13, marginBottom: 6 }}><b>Category:</b> {selected.category}</div>
            <div style={{ fontSize: 13, marginBottom: 6 }}><b>Officer:</b> {selected.guardName}</div>
            <div style={{ fontSize: 13, marginBottom: 12 }}><b>Time:</b> {formatTime(selected.createdAt)}</div>
            <div style={S.sectionTitle}>Description</div>
            <div style={{ fontSize: 13, color: '#9CA3AF', lineHeight: 1.6, marginBottom: 12 }}>
              {selected.description || selected.full_description || 'No description provided.'}
            </div>
            <div style={S.sectionTitle}>Action taken</div>
            <div style={{ fontSize: 13, color: '#9CA3AF', lineHeight: 1.6 }}>
              {selected.action_taken || 'No action recorded.'}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

// ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ PATROLS ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬
function Patrols({ patrols, routes }) {
  return (
    <div style={S.section}>
      <div style={S.grid2}>
        <div style={S.card}>
          <div style={S.sectionTitle}>Recent patrols</div>
          <table style={S.table}>
            <thead>
              <tr>
                <th style={S.th}>Route</th>
                <th style={S.th}>Site</th>
                <th style={S.th}>Officer</th>
                <th style={S.th}>Points</th>
                <th style={S.th}>Status</th>
              </tr>
            </thead>
            <tbody>
              {patrols.map((p, i) => (
                <tr key={i}>
                  <td style={S.td}>{p.route_name || 'Unknown'}</td>
                  <td style={S.td}>{p.site || 'N/A'}</td>
                  <td style={{ ...S.td, fontSize: 11 }}>{p.officer_email || 'Unknown'}</td>
                  <td style={S.td}>{p.points_checked}/{p.points_total}</td>
                  <td style={S.td}>
                    <span style={S.badge2(p.completed ? '#2E7D32' : '#F57F17')}>
                      {p.completed ? 'Complete' : 'Incomplete'}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div style={S.card}>
          <div style={S.sectionTitle}>Patrol routes</div>
          {routes.map((r, i) => (
            <div key={i} style={{ padding: '10px 0', borderBottom: '1px solid #1E3A5F22' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div>
                  <div style={{ fontSize: 13, fontWeight: 700 }}>{r.name}</div>
                  <div style={{ fontSize: 11, color: '#9CA3AF' }}>{r.site} Ãƒâ€šÃ‚Â· {(r.points || []).length} points Ãƒâ€šÃ‚Â· {r.schedule}</div>
                </div>
                <span style={S.badge2(r.active ? '#2E7D32' : '#9CA3AF')}>{r.active ? 'Active' : 'Inactive'}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

// ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ ANALYTICS ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬
function Analytics({ incidents, patrols, dailyLogs }) {
  const categoryData = incidents.reduce((acc, inc) => {
    const cat = inc.category || 'Unknown';
    acc[cat] = (acc[cat] || 0) + 1;
    return acc;
  }, {});

  const chartData = Object.entries(categoryData).map(([name, count]) => ({ name: name.substring(0, 12), count }));

  const completionRate = patrols.length > 0
    ? Math.round((patrols.filter(p => p.completed).length / patrols.length) * 100)
    : 0;

  const avgChecks = dailyLogs.length > 0
    ? Math.round(dailyLogs.reduce((sum, l) => sum + (l.checks_completed || 0), 0) / dailyLogs.length * 10) / 10
    : 0;

  return (
    <div style={S.section}>
      <div style={{ ...S.grid4, marginBottom: 16 }}>
        <div style={S.card}>
          <div style={S.cardLabel}>Total incidents</div>
          <div style={S.statNum('#D32F2F')}>{incidents.length}</div>
        </div>
        <div style={S.card}>
          <div style={S.cardLabel}>Patrol completion</div>
          <div style={S.statNum('#2E7D32')}>{completionRate}%</div>
        </div>
        <div style={S.card}>
          <div style={S.cardLabel}>Avg daily checks</div>
          <div style={S.statNum('#F57F17')}>{avgChecks}/4</div>
        </div>
        <div style={S.card}>
          <div style={S.cardLabel}>Daily logs</div>
          <div style={S.statNum('#1A1A2E')}>{dailyLogs.length}</div>
        </div>
      </div>

      <div style={S.grid2}>
        <div style={S.card}>
          <div style={S.sectionTitle}>Incidents by category</div>
          <ResponsiveContainer width="100%" height={200}>
            <BarChart data={chartData}>
              <XAxis dataKey="name" tick={{ fill: '#9CA3AF', fontSize: 10 }} />
              <YAxis tick={{ fill: '#9CA3AF', fontSize: 10 }} />
              <Tooltip contentStyle={{ background: '#FFFFFF', border: '1px solid #1E3A5F', color: '#F8FAFC' }} />
              <Bar dataKey="count" fill="#1E3A5F" radius={4} />
            </BarChart>
          </ResponsiveContainer>
        </div>

        <div style={S.card}>
          <div style={S.sectionTitle}>Recent daily logs</div>
          <table style={S.table}>
            <thead>
              <tr>
                <th style={S.th}>Site</th>
                <th style={S.th}>Date</th>
                <th style={S.th}>Checks</th>
                <th style={S.th}>Type</th>
              </tr>
            </thead>
            <tbody>
              {dailyLogs.slice(0, 6).map((log, i) => (
                <tr key={i}>
                  <td style={S.td}>{log.site_location || 'Unknown'}</td>
                  <td style={{ ...S.td, fontSize: 11, color: '#9CA3AF' }}>{log.log_date || ''}</td>
                  <td style={S.td}>
                    <span style={S.badge2(log.checks_completed === 4 ? '#2E7D32' : '#F57F17')}>
                      {log.checks_completed || 0}/4
                    </span>
                  </td>
                  <td style={{ ...S.td, fontSize: 11, color: '#9CA3AF' }}>{(log.occurrence_type || '').substring(0, 20)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

// ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ TEAM ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬
function Team({ users, tenantId, userRole, focusOfficerEmail, onFocusHandled }) {
  const [selected, setSelected] = React.useState(null);
  const [search, setSearch] = React.useState('');
  const [filterRole, setFilterRole] = React.useState('all');
  const [showInviteModal, setShowInviteModal] = React.useState(false);

  // Deep-link from the global search / Live Ops feed: open a specific officer.
  React.useEffect(() => {
    if (!focusOfficerEmail) return;
    const match = users.find(u => (u.email || '').toLowerCase() === focusOfficerEmail.toLowerCase());
    if (match) { setSelected(match); setSearch(''); setFilterRole('all'); }
    onFocusHandled && onFocusHandled();
  }, [focusOfficerEmail]); // eslint-disable-line react-hooks/exhaustive-deps

  const roleColor = (role) => {
    const colors = { facility_manager: '#C9A84C', general_manager: '#7C3AED', head_of_security: '#1A1A2E', supervisor: '#2E7D52', officer: '#6B6055', admin: '#C9A84C' };
    return colors[role] || '#6B6055';
  };
  const roleBg = (role) => {
    const colors = { facility_manager: '#FFF8E7', general_manager: '#F3F0FF', head_of_security: '#F0F2F8', supervisor: '#F0FFF4', officer: '#F5F5F5', admin: '#FFF8E7' };
    return colors[role] || '#F5F5F5';
  };
  const initials = (u) => {
    const n = u.name || u.displayName || u.email || '?';
    return n.split(' ').map(p => p[0]).join('').toUpperCase().slice(0, 2);
  };

  const filtered = users.filter(u => {
    if (filterRole !== 'all' && u.role !== filterRole) return false;
    const q = search.toLowerCase();
    return !q || (u.name || '').toLowerCase().includes(q) || (u.email || '').toLowerCase().includes(q);
  });

  const roles = [...new Set(users.map(u => u.role).filter(Boolean))];

  return (
    <div style={S.section}>
      {/* Header bar */}
      <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:20 }}>
        <div>
          <div style={{ fontSize:20, fontWeight:800, color:'#1A1A2E' }}>Team Directory</div>
          <div style={{ fontSize:12, color:'#9B8F7A', marginTop:2 }}>{users.length} members across all roles</div>
        </div>
        <div style={{ display:'flex', gap:8 }}>
          <input
            placeholder="Search name or email..."
            value={search} onChange={e => setSearch(e.target.value)}
            style={{ ...S.input, width:200, padding:'7px 12px', fontSize:12 }}
          />
          <select value={filterRole} onChange={e => setFilterRole(e.target.value)}
            style={{ ...S.input, width:'auto', padding:'7px 12px', fontSize:12, cursor:'pointer' }}>
            <option value="all">All Roles</option>
            {roles.map(r => <option key={r} value={r}>{r.replace(/_/g,' ')}</option>)}
          </select>
          {userRole === 'admin' && (
            <button onClick={() => setShowInviteModal(true)}
              style={{ background:'#C9A84C', color:'#1A1A2E', border:'none', padding:'7px 14px', borderRadius:8, cursor:'pointer', fontSize:12, fontWeight:800 }}>
              + Invite officer
            </button>
          )}
        </div>
      </div>

      {showInviteModal && <InviteOfficerModal tenantId={tenantId} onClose={() => setShowInviteModal(false)} />}

      <div style={{ display:'grid', gridTemplateColumns: selected ? '1fr 360px' : '1fr', gap:16 }}>
        {/* Officer Cards Grid */}
        <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill, minmax(260px, 1fr))', gap:14, alignContent:'start' }}>
          {filtered.map((user, i) => (
            <div key={i}
              onClick={() => setSelected(selected?.email === user.email ? null : user)}
              style={{
                background:'#FFFFFF', border: selected?.email === user.email ? '2px solid #C9A84C' : '1px solid #E2DDD6',
                borderRadius:12, padding:18, cursor:'pointer',
                transition:'all 0.15s',
                boxShadow: selected?.email === user.email ? '0 4px 20px #C9A84C22' : 'none'
              }}>
              <div style={{ display:'flex', alignItems:'center', gap:12, marginBottom:14 }}>
                <div style={{
                  width:46, height:46, borderRadius:12,
                  background: selected?.email === user.email ? '#1A1A2E' : '#F4F2EE',
                  display:'flex', alignItems:'center', justifyContent:'center',
                  fontSize:15, fontWeight:800,
                  color: selected?.email === user.email ? '#C9A84C' : '#1A1A2E',
                  flexShrink:0, border:'1px solid #E2DDD6'
                }}>
                  {initials(user)}
                </div>
                <div style={{ flex:1, minWidth:0 }}>
                  <div style={{ fontSize:14, fontWeight:700, color:'#1A1A2E', whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis' }}>
                    {user.name || user.displayName || 'Unknown'}
                  </div>
                  <div style={{ fontSize:11, color:'#9B8F7A', whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis' }}>
                    {user.email}
                  </div>
                </div>
              </div>
              <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center' }}>
                <span style={{ background: roleBg(user.role), color: roleColor(user.role), padding:'3px 10px', borderRadius:20, fontSize:11, fontWeight:700, textTransform:'capitalize' }}>
                  {(user.role || 'officer').replace(/_/g,' ')}
                </span>
                <span style={{ background: user.active !== false ? '#F0FFF4' : '#F5F5F5', color: user.active !== false ? '#2E7D52' : '#9B8F7A', padding:'3px 10px', borderRadius:20, fontSize:11, fontWeight:700 }}>
                  {user.active !== false ? 'Active' : 'Inactive'}
                </span>
              </div>
              {user.sia_number && user.sia_number !== 'N/A' && (
                <div style={{ marginTop:10, paddingTop:10, borderTop:'1px solid #F4F0E8', fontSize:11, color:'#9B8F7A' }}>
                  SIA: <span style={{ fontFamily:'monospace', color:'#1A1A2E', fontWeight:600 }}>{user.sia_number}</span>
                </div>
              )}
            </div>
          ))}
          {filtered.length === 0 && (
            <div style={{ ...S.card, gridColumn:'1/-1', textAlign:'center', color:'#9B8F7A', padding:48 }}>
              No team members match your search.
            </div>
          )}
        </div>

        {/* Officer Profile Panel */}
        {selected && (
          <div style={{ background:'#FFFFFF', border:'1px solid #E2DDD6', borderRadius:14, padding:24, height:'fit-content', position:'sticky', top:80 }}>
            {/* Profile header */}
            <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:20 }}>
              <div style={{ display:'flex', alignItems:'center', gap:14 }}>
                <div style={{ width:60, height:60, borderRadius:14, background:'#1A1A2E', display:'flex', alignItems:'center', justifyContent:'center', fontSize:20, fontWeight:800, color:'#C9A84C' }}>
                  {initials(selected)}
                </div>
                <div>
                  <div style={{ fontSize:17, fontWeight:800, color:'#1A1A2E' }}>{selected.name || selected.displayName || 'Unknown'}</div>
                  <span style={{ background: roleBg(selected.role), color: roleColor(selected.role), padding:'3px 10px', borderRadius:20, fontSize:11, fontWeight:700, textTransform:'capitalize' }}>
                    {(selected.role || 'officer').replace(/_/g,' ')}
                  </span>
                </div>
              </div>
              <button onClick={() => setSelected(null)} style={{ background:'none', border:'1px solid #E2DDD6', borderRadius:6, padding:'4px 10px', cursor:'pointer', fontSize:12, color:'#9B8F7A' }}>Close</button>
            </div>

            {/* Profile details */}
            {[
              { label:'Email', value: selected.email },
              { label:'Phone', value: selected.phone || 'Not provided' },
              { label:'SIA Licence', value: selected.sia_number || 'Not provided' },
              { label:'SIA Expiry', value: selected.sia_expiry || 'Not provided' },
              { label:'DBS Number', value: selected.dbs_number || 'Not provided' },
              { label:'Start Date', value: selected.start_date || 'Not provided' },
              { label:'Site', value: selected.site || 'Not assigned' },
              { label:'Tenant', value: selected.tenant_id || '' },
            ].map(({ label, value }) => (
              <div key={label} style={{ display:'flex', justifyContent:'space-between', padding:'9px 0', borderBottom:'1px solid #F4F0E8' }}>
                <span style={{ fontSize:12, color:'#9B8F7A', fontWeight:600 }}>{label}</span>
                <span style={{ fontSize:12, color:'#1A1A2E', fontWeight:500, textAlign:'right', maxWidth:180, wordBreak:'break-all' }}>{value}</span>
              </div>
            ))}

            {/* Status + actions */}
            <div style={{ marginTop:16, display:'flex', gap:8 }}>
              <div style={{ flex:1, background: selected.active !== false ? '#F0FFF4' : '#FFF5F5', borderRadius:8, padding:'10px 14px', textAlign:'center' }}>
                <div style={{ fontSize:10, color:'#9B8F7A', textTransform:'uppercase', letterSpacing:1, marginBottom:4 }}>Status</div>
                <div style={{ fontSize:14, fontWeight:800, color: selected.active !== false ? '#2E7D52' : '#C0392B' }}>
                  {selected.active !== false ? 'Active' : 'Inactive'}
                </div>
              </div>
              <div style={{ flex:1, background:'#F8F7F4', borderRadius:8, padding:'10px 14px', textAlign:'center' }}>
                <div style={{ fontSize:10, color:'#9B8F7A', textTransform:'uppercase', letterSpacing:1, marginBottom:4 }}>Documents</div>
                <div style={{ fontSize:14, fontWeight:800, color:'#1A1A2E' }}>View Vault</div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

// ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ MAIN APP ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬
export default function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [tab, setTab] = useState(() => {
    // Will be updated once role loads
    return 'live';
  });
  const [incidents, setIncidents] = useState([]);
  const [officers, setOfficers] = useState([]);
  const [patrols, setPatrols] = useState([]);
  const [routes, setRoutes] = useState([]);
  const [dailyLogs, setDailyLogs] = useState([]);
  const [users, setUsers] = useState([]);
  const [threatLevel, setThreatLevel] = useState('SUBSTANTIAL');
  const [tenantId, setTenantId] = useState('osecurity-ltd');
  const [userRole, setUserRole] = useState('officer');
  const [showIncidentModal, setShowIncidentModal] = useState(false);
  const [showPatrolModal, setShowPatrolModal] = useState(false);
  const [editingIncident, setEditingIncident] = useState(null);
  const [editingRoute, setEditingRoute] = useState(null);
  const [displayName, setDisplayName] = useState('');
  const [searchQuery, setSearchQuery] = useState('');
  const [profileOpen, setProfileOpen] = useState(false);
  // Loaded for global search (visitors/cases aren't otherwise in App memory).
  const [visitors, setVisitors] = useState([]);
  const [cases, setCases] = useState([]);
  // Deep-link target consumed by a module to open a specific item's detail.
  const [focus, setFocus] = useState(null);
  const profileRef = useRef(null);
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [openGroups, setOpenGroups] = useState(() =>
    Object.fromEntries(NAV_GROUPS.map(g => [g.id, true]))
  );
  const toggleGroup = (id) => setOpenGroups(g => ({ ...g, [id]: !g[id] }));

  useEffect(() => {
    return onAuthStateChanged(auth, (u) => { setUser(u); setLoading(false); });
  }, []);

  useEffect(() => {
    if (!profileOpen) return;
    const handleClick = (e) => {
      if (profileRef.current && !profileRef.current.contains(e.target)) setProfileOpen(false);
    };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, [profileOpen]);

  useEffect(() => {
    if (!user) return;
    const run = async () => {

    // Get current user's tenant_id
    const userDoc = await getDoc(doc(db, 'users', user.uid));
    const tid = userDoc.data()?.tenant_id || 'osecurity-ltd';
    const role = userDoc.data()?.role || 'officer';
    setTenantId(tid);
    setUserRole(role);
    setDisplayName(userDoc.data()?.display_name || '');
    const tenantId = tid;

    const unsubs = [
      onSnapshot(query(collection(db, 'incidents'), where('companyId', '==', tenantId), orderBy('createdAt', 'desc'), limit(50)),
        snap => setIncidents(snap.docs.map(d => ({ ...d.data(), _id: d.id })))),
      onSnapshot(query(collection(db, 'guard_shift_status'), where('tenant_id', '==', tenantId), where('active', '==', true)),
        snap => setOfficers(snap.docs.map(d => d.data()))),
      onSnapshot(query(collection(db, 'patrols'), where('company_id', '==', tenantId), orderBy('completed_at', 'desc'), limit(20)),
        snap => setPatrols(snap.docs.map(d => ({ ...d.data(), id: d.id })))),
      onSnapshot(query(collection(db, 'patrol_routes'), where('company_id', '==', tenantId)),
        snap => setRoutes(snap.docs.map(d => ({ ...d.data(), _id: d.id })))),
      onSnapshot(query(collection(db, 'daily_logs'), where('company_id', '==', tenantId), orderBy('date_timestamp', 'desc'), limit(20)),
        snap => setDailyLogs(snap.docs.map(d => d.data()))),
      onSnapshot(query(collection(db, 'users'), where('tenant_id', '==', tenantId)),
        snap => setUsers(snap.docs.map(d => ({ ...d.data(), _id: d.id })))),
      // Global-search backing data — tenant-scoped here via the REAL tenant
      // (users/{uid}.tenant_id), unlike VisitorManagement/CaseManagement which
      // read auth.currentUser.tenantId (always null → default tenant). See the
      // Synapse cleanup backlog. limit(200) is fine at current scale.
      onSnapshot(query(collection(db, 'visitors'), where('tenant_id', '==', tenantId), limit(200)),
        snap => setVisitors(snap.docs.map(d => ({ ...d.data(), id: d.id })))),
      onSnapshot(query(collection(db, 'cases'), where('tenant_id', '==', tenantId), orderBy('created_at', 'desc'), limit(200)),
        snap => setCases(snap.docs.map(d => ({ ...d.data(), id: d.id })))),
      onSnapshot(doc(db, 'setting', 'threat_level'),
        snap => { if (snap.exists()) setThreatLevel(snap.data().level || 'SUBSTANTIAL'); }),
    ];

    };
    run();
  }, [user]);

  if (loading) return <div style={{ ...S.app, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 18 }}>LoadingÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦</div>;
  if (!user) return <Login />;

  const tabs = [
    ...(can(userRole, 'viewLiveOps') ? [{ id: 'live', label: 'Live Ops' }] : []),
    ...(can(userRole, 'viewEmergency') ? [{ id: 'emergency', label: 'Emergency' }] : []),
    ...(can(userRole, 'viewIncidents') ? [{ id: 'incidents', label: 'Incidents' }] : []),
    ...(can(userRole, 'viewPatrols') ? [{ id: 'patrols', label: 'Patrols' }] : []),
    ...(can(userRole, 'manageCheckpoints') ? [{ id: 'checkpoints', label: 'Checkpoints' }] : []),
    ...(can(userRole, 'viewAnalytics') ? [{ id: 'analytics', label: 'Analytics' }] : []),
    ...(can(userRole, 'viewTeam') ? [{ id: 'team', label: 'Team' }] : []),
    ...(can(userRole, 'manageTeam') ? [{ id: 'vault', label: 'Vault' }] : []),
    ...(can(userRole, 'manageTeam') ? [{ id: 'shifts', label: 'Shifts' }] : []),
    ...(can(userRole, 'viewTeam') ? [{ id: 'leave', label: 'Leave' }] : []),
    ...(can(userRole, 'createAlerts') ? [{ id: 'notifications', label: 'Alerts' }] : []),
    ...(can(userRole, 'viewTeam') ? [{ id: 'chat', label: 'Chat' }] : []),
    ...(can(userRole, 'viewTeam') ? [{ id: 'visitors', label: 'Visitors' }] : []),
    ...(can(userRole, 'viewTeam') ? [{ id: 'cases', label: 'Cases' }] : []),
  ];

  // Shared "navigate to module + open detail for item X". Used by both the Live
  // Ops feed rows and the global search results — built once, used in both.
  // `opts.navigate` switches tabs (search does; the Live feed opens the incident
  // modal in place without leaving Live Ops).
  const openItem = (type, item, opts = {}) => {
    switch (type) {
      case 'incident':
        if (opts.navigate) setTab('incidents');
        setEditingIncident(item);
        setShowIncidentModal(true);
        break;
      case 'patrol':
        setFocus({ type: 'patrol', item });
        setTab('patrols');
        break;
      case 'case':
        setFocus({ type: 'case', item });
        setTab('cases');
        break;
      case 'visitor':
        // No visitor detail panel — surface the row via the board's search box.
        setFocus({ type: 'visitor', term: item.visitor_name || item.visitor_email || '' });
        setTab('visitors');
        break;
      case 'officer': {
        // Team is the destination; roles without viewTeam have none, so no-op
        // (the caller also hides the affordance for them).
        if (!can(userRole, 'viewTeam')) return;
        const email = item.email || item.guardEmail || null;
        if (!email) return;
        setFocus({ type: 'officer', email });
        setTab('team');
        break;
      }
      default:
        break;
    }
  };

  return (
    <div style={S.app}>
      <div style={S.topBar}>
        <div style={S.topBarLeft}>
          <button onClick={() => window.location.reload()} title="Reload dashboard" style={{ display: 'flex', alignItems: 'center', gap: 10, background: 'none', border: 'none', cursor: 'pointer', padding: 0 }}>
            <div style={{ width: 32, height: 32, background: '#C9A84C', borderRadius: 7, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <span style={{ color: '#1A1A2E', fontSize: 13, fontWeight: 900, letterSpacing: -0.5 }}>OS</span>
            </div>
            <span style={S.wordmark}>OSECURE OPS</span>
          </button>
        </div>

        <GlobalSearch
          query={searchQuery}
          onQueryChange={setSearchQuery}
          incidents={incidents}
          patrols={patrols}
          visitors={visitors}
          cases={cases}
          users={users}
          userRole={userRole}
          onOpen={openItem}
        />

        <div style={S.topBarRight}>
          <button style={S.iconBtn} title="Toggle sidebar" onClick={() => setSidebarOpen(o => !o)}>
            <MenuIcon />
          </button>
          <button style={S.iconBtn} title="Notifications — coming soon">
            <BellIcon />
          </button>
          <button style={S.iconBtn} title="Help — coming soon">
            <HelpIcon />
          </button>

          <div style={{ position: 'relative' }} ref={profileRef}>
            <button style={S.profileCluster} onClick={() => setProfileOpen(o => !o)}>
              <div style={S.avatar}>{(displayName || user.email || '?').charAt(0).toUpperCase()}</div>
              <div style={S.profileInfo}>
                <div style={S.profileNameTxt}>{displayName || user.email}</div>
                <div style={S.profileRoleTxt}>{getRoleLabel(userRole)}</div>
              </div>
              <ChevronDownIcon />
            </button>

            {profileOpen && (
              <div style={S.dropdown}>
                <div style={S.dropdownHeader}>
                  <div style={S.dropdownEmail}>{user.email}</div>
                  <div style={S.dropdownSub}>oSecurity Ltd &middot; {getRoleLabel(userRole)}</div>
                </div>
                {/* TODO: build Profile/Settings/Company pages */}
                <button style={S.dropdownItem(true)} disabled>Profile <span style={S.soonTag}>Soon</span></button>
                <button style={S.dropdownItem(true)} disabled>Settings <span style={S.soonTag}>Soon</span></button>
                <button style={S.dropdownItem(true)} disabled>Company <span style={S.soonTag}>Soon</span></button>
                <button
                  style={{ ...S.dropdownItem(false), borderTop: '1px solid #EAE6DE' }}
                  onClick={() => { setProfileOpen(false); signOut(auth); }}
                >
                  Sign out
                </button>
              </div>
            )}
          </div>
        </div>
      </div>

      <div style={S.shellRow}>
        <div style={S.sidebar(sidebarOpen)}>
          {NAV_GROUPS.map(group => {
            const items = group.tabIds.map(id => tabs.find(t => t.id === id)).filter(Boolean);
            if (items.length === 0) return null;
            const isOpen = openGroups[group.id];
            return (
              <div key={group.id} style={S.sidebarGroup}>
                <button style={S.sidebarGroupHeader} onClick={() => toggleGroup(group.id)}>
                  <span>{group.label}</span>
                  <ChevronDownIcon style={{ transform: isOpen ? 'rotate(0deg)' : 'rotate(-90deg)', transition: 'transform 0.15s', flexShrink: 0 }} />
                </button>
                {isOpen && items.map(t => (
                  <button key={t.id} style={S.sidebarItem(tab === t.id)} onClick={() => setTab(t.id)}>
                    <TabIcon id={t.id} />
                    <span>{t.label}</span>
                  </button>
                ))}
              </div>
            );
          })}
        </div>

        <div style={S.main}>
          <div style={S.actionRow}>
            {can(userRole, 'createAlerts') && <button onClick={() => { setEditingIncident(null); setShowIncidentModal(true); }} style={{ background: '#D32F2F22', color: '#D32F2F', border: '1px solid #D32F2F44', padding: '6px 12px', borderRadius: 8, cursor: 'pointer', fontSize: 12, fontWeight: 700 }}>+ Incident</button>}
            {can(userRole, 'manageTeam') && <button onClick={() => { setEditingRoute(null); setShowPatrolModal(true); }} style={{ background: '#1E3A5F', color: '#fff', border: 'none', padding: '6px 12px', borderRadius: 8, cursor: 'pointer', fontSize: 12, fontWeight: 700 }}>+ Patrol</button>}
            <button onClick={() => exportToExcel({ incidents, patrols, officers, users, dailyLogs })} style={{ background: '#C9A84C', color: '#1A1A2E', border: 'none', padding: '6px 14px', borderRadius: 7, cursor: 'pointer', fontSize: 12, fontWeight: 800 }}>Export Excel</button>
          </div>

          {showIncidentModal && <IncidentModal incident={editingIncident} tenantId={tenantId} onClose={() => { setShowIncidentModal(false); setEditingIncident(null); }} onSaved={() => {}} />}
          {showPatrolModal && <PatrolModal route={editingRoute} tenantId={tenantId} onClose={() => { setShowPatrolModal(false); setEditingRoute(null); }} onSaved={() => {}} />}
          {tab === 'live' && <LiveOps incidents={incidents} officers={officers} patrols={patrols} threatLevel={threatLevel} onOpenIncident={(inc) => openItem('incident', inc)} onOpenOfficer={(o) => openItem('officer', o)} canOpenOfficer={can(userRole, 'viewTeam')} onOpenPatrol={(p) => openItem('patrol', p)} />}
          {tab === 'emergency' && <EmergencyPage tenantId={tenantId} users={users} />}
          {tab === 'incidents' && <IncidentsPage incidents={incidents} tenantId={tenantId} userRole={userRole} />}
          {tab === 'patrols' && <PatrolsPage patrols={patrols} routes={routes} tenantId={tenantId} userRole={userRole} focusLog={focus?.type === 'patrol' ? focus.item : null} onFocusHandled={() => setFocus(null)} />}
          {tab === 'checkpoints' && <CheckpointsPage tenantId={tenantId} userRole={userRole} />}
          {tab === 'analytics' && <AnalyticsPage incidents={incidents} patrols={patrols} dailyLogs={dailyLogs} users={users} routes={routes} />}
          {tab === 'vault' && <DocumentVault />}
          {tab === 'shifts' && <ShiftScheduler />}
          {tab === 'leave' && <LeaveRequests userRole={userRole} />}
          {tab === 'team' && <Team users={users} tenantId={tenantId} userRole={userRole} focusOfficerEmail={focus?.type === 'officer' ? focus.email : null} onFocusHandled={() => setFocus(null)} />}
          {tab === 'notifications' && <NotificationCentre />}
          {tab === 'chat' && <ChatCentre />}
          {tab === 'visitors' && <VisitorManagement focusTerm={focus?.type === 'visitor' ? focus.term : null} onFocusHandled={() => setFocus(null)} />}
          {tab === 'cases' && <CaseManagement focusCase={focus?.type === 'case' ? focus.item : null} onFocusHandled={() => setFocus(null)} />}
        </div>
      </div>
    </div>
  );
}





